import { NoteSearchOutlineIcon } from './NoteSearchOutlineIcon';

/**
 * author: Colton Wiscombe
 * id FAA55692-47B7-492B-897A-9225E7F0C766
 * name note-search-outline
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-search-outline.svg
 * tags
 */
export const StickyNoteSearchOutlineIcon = NoteSearchOutlineIcon;
export default StickyNoteSearchOutlineIcon